import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    clearSelectedInvoices, selectPayer
} from "../../actions/InvoiceActions";
import {getPayerAccounts} from "../../selectors/Selectors";


export class PayerSelect extends Component<any, any> {

    constructor(props) {
        super(props);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
    }

    handleCustomerChange = (e) => {
        this.props.clearSelectedInvoices();
        this.props.selectPayer(parseInt(e.target.value));
    };

    truncateOption(text) {
        const maxLength = 24;
        if (text.length > maxLength) {
            return text.substr(0, maxLength) + '...';
        }
        return text;
    }

    render() {
        let value = this.props.selectedSecondaryAccount;
        let options = Object.values(this.props.payerAccounts).map((account:any, index) => {
            return {value: account.PrimaryAcct, label: `${account.PrimaryAcct}-${account.Name}`, account_number: account.PrimaryAcct}
        });
       // let disabled = this.props.payerAccounts && this.props.payerAccounts.length <= 1;
        let disabled = !this.props.payerAccounts ||
            Object.keys(this.props.payerAccounts).length <= 1;
        return <div className='customSelect payer-select'>
            <select
                onChange={this.handleCustomerChange}
                disabled={disabled}
                value={value}
                className="invoicesHeadingInput form-control">
                {options.map(option => {
                    return (
                        <option
                            key={option.value}
                            value={option.value}>
                            {this.truncateOption(option.label)}
                        </option>
                    )
                })}
            </select>
            <i className="fas fa-chevron-down select-arrow"/>
        </div>
    }
}

export default connect<any, any, any, any>((state, props) => {
    return {
        selectedSecondaryAccount: state.user_options.selectedSecondaryAccount,
        payerAccounts: getPayerAccounts(state),
    }
}, {
    clearSelectedInvoices,
    selectPayer
})(PayerSelect);